// extracted by mini-css-extract-plugin
module.exports = {"backButton":"BackPage_backButton__hcYCV","btnBack":"BackPage_btnBack__2qh4b","angle":"BackPage_angle__2cT-m","left":"BackPage_left__1VpIB","backTitle":"BackPage_backTitle__38Ed4"};